module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-door-vertical-end.a54f89ba.png";